import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiResponseDocument } from '../../schema'

type RequestRelationships = OpalApiResponseDocument<
  'ReadBoardCollaboratorV3',
  200
>['data']['relationships']
type RequiredAttributes = OpalApiResponseDocument<
  'ReadBoardCollaboratorV3',
  200
>['data']['attributes']

const defaultAttributes: RequiredAttributes = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
}

export const resourceObject = (
  relationships: RequestRelationships
): OpalApiComponent<'V3', 'board_collaborator'> => {
  return {
    id: uuidv4(),
    type: 'board_collaborator',
    attributes: defaultAttributes,
    relationships,
  }
}
